export function bfs(root, target) {
    let queue = Array.isArray(root) ? [...root] : [root];
    let visited = new Set();
    let safetyCounter = 0;
    const maxIterations = 10000; // arbitrary number to prevent infinite loops
    const pathStack = new Set(); // to keep track of the path

    while (queue.length > 0) {
        if (safetyCounter++ > maxIterations) {
            console.error(
                "Safety counter reached, potential infinite loop detected."
            );
            return null;
        }

        let current = queue.shift();
        if (!current) continue;

        // if current node is already in the path, then there is a cycle
        if (pathStack.has(current.id)) {
            console.error(
                `Cycle detected involving node with id: ${current.id}`
            );
            return null;
        }

        pathStack.add(current.id);

        if (current.id == target) {
            return current;
        }

        if (
            current.children &&
            Array.isArray(current.children) &&
            current.children.length > 0
        ) {
            current.children.forEach((child) => {
                if (!visited.has(child.id)) {
                    queue.push(child);
                    visited.add(child.id);
                }
            });
        }

        // remove current node from path
        pathStack.delete(current.id);
    }
    return null;
}

// roman numbers
function romanToInt(roman) {
    const romanMap = {
        I: 1,
        V: 5,
        X: 10,
        L: 50,
        C: 100,
        D: 500,
        M: 1000,
    };
    let result = 0;
    for (let i = 0; i < roman.length; i++) {
        const current = romanMap[roman[i]];
        const next = romanMap[roman[i + 1]];
        if (next && current < next) {
            result -= current;
        } else {
            result += current;
        }
    }
    return result;
}

// compare function
export function customRomanSort(a, b) {
    const romanRegex = /^[IVXLCDM]+/; // regex to match roman numbers

    // handle null names
    if (!a.name && !b.name) return 0;
    if (!a.name) return 1;
    if (!b.name) return -1;

    const romanA = a.name.match(romanRegex);
    const romanB = b.name.match(romanRegex);

    // if one of the two is a roman number, it comes first
    if (romanA && !romanB) return -1;
    if (!romanA && romanB) return 1;

    if (romanA && romanB) {
        // both are roman numbers, compare them
        const numA = romanToInt(romanA[0]);
        const numB = romanToInt(romanB[0]);
        if (numA !== numB) {
            return numA - numB;
        }
    }

    // alphabetical order for the rest
    return a.name.localeCompare(b.name);
}

export function customArabicSort(a, b) {
    // function to extract parts of the string
    function extractParts(str) {
        const match = str.match(/^([^\d]*)(\d+)?/); // splits the string in text and number
        return {
            text: match[1].trim().toUpperCase(),
            number: match[2] ? parseInt(match[2], 10) : null,
        };
    }

    if (!a && !b) return 0;
    if (!a) return 1;
    if (!b) return -1;

    // extract parts of the string
    const partA = extractParts(a.trim());
    const partB = extractParts(b.trim());

    // compare the text
    const textComparison = partA.text.localeCompare(partB.text);
    if (textComparison !== 0) {
        return textComparison;
    }

    // compare the numbers
    if (partA.number !== null && partB.number !== null) {
        return partA.number - partB.number;
    }

    if (partA.number !== null) return -1;
    if (partB.number !== null) return 1;

    return 0;
}
